import {Modal, SimpleGrid, Stack, Text} from '@mantine/core';
import React from 'react';

import {PlateFieldValue} from 'notebook/integrations/plate-maps/scratch-plates/ScratchPlateDesignSummaryUtil';
import {PlateSchema} from 'samples/storables/StorableSchemaConstants';
import FieldLabel from 'ui-library/inputs/FieldLabel';

export interface PlateMetadataFieldsModalProps {
  opened: boolean;
  onClose: () => void;
  plateSchema?: PlateSchema | null;
  fields: ReadonlyArray<PlateFieldValue>;
  /** Whether the fields belong to a plate design, as opposed to a created plate record. */
  isPlateDesign: boolean;
}

/** Read-only modal listing a scratch plate's plate-level ("whole plate") metadata or schema fields. */
export default function PlateMetadataFieldsModal({
  opened,
  onClose,
  plateSchema,
  fields,
  isPlateDesign,
}: PlateMetadataFieldsModalProps): JSX.Element {
  const sortedFields = [...fields].sort((a, b) => a.name.localeCompare(b.name));
  const title = `${isPlateDesign ? 'Plate design' : 'Plate record'} fields`;

  return (
    <Modal opened={opened} onClose={onClose} title={title} size="md">
      <Stack spacing="md">
        {plateSchema != null && (
          <Stack spacing={2}>
            <FieldLabel label="Schema" />
            <Text>{plateSchema.name}</Text>
          </Stack>
        )}
        {sortedFields.length === 0 ? (
          <Text c="dimmed">No plate fields.</Text>
        ) : (
          <SimpleGrid cols={2}>
            {sortedFields.map((field) => (
              <Stack key={field.id} spacing={2}>
                <FieldLabel label={field.name} />
                {field.value != null ? <Text>{String(field.value)}</Text> : <Text c="dimmed">—</Text>}
              </Stack>
            ))}
          </SimpleGrid>
        )}
      </Stack>
    </Modal>
  );
}
